module.exports = __webpack_public_path__ + "static/media/ic_badge_gold.7cd4e458.png";